<template>
<div class="cerificate padding-20 bgc box-shadow">
    <router-view></router-view>
</div>
</template>

<script>
export default {
    name: 'cerificate',
    data() {
        return {}
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.cerificate {
    min-width: 1100px;
    font-family: PingFangSC-Regular,PingFang SC;
}
</style>